/******************************************
*  Author : Riccardo Di Dato
*  Created On : Fri Apr 29 2022
*  File : InvalidInputError.ts
*******************************************/
import { ShatsuGenericError } from "./ShatsuGenericError.js";
/**
 * Input non valido
 *
 * @author Riccardo Di Dato
 */
export class InvalidInputError extends ShatsuGenericError {
    constructor(m, parent = null) {
        super(m, parent);
        Object.setPrototypeOf(this, InvalidInputError.prototype);
    }
}
